import type { ResidenceData } from '@repo/sdk/gen'
import { useWatch } from 'react-hook-form'
import { seatsOf } from '../-lib/residence-form'

/** The seats of the sites and the quotas, while the manager types. */
export function useSeats() {
	const [sites, q30SingleBeds, q30DoubleBeds] = useWatch<
		ResidenceData,
		['sites', 'q30SingleBeds', 'q30DoubleBeds']
	>({ name: ['sites', 'q30SingleBeds', 'q30DoubleBeds'] })
	return seatsOf({ sites, q30SingleBeds, q30DoubleBeds })
}
